import { useToast } from '@winnin/winnin_ui.components.toast'

import { useDashboardModals } from 'contexts/DashboardModalsContext'
import { useDashboardMutations } from 'hooks-queries/dashboards'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import { DELETE_DASHBOARD_FOLDER_LOG } from './delete-dashboard-folder-modal.consts'
import { translations } from './delete-dashboard-folder-modal.i18n'
import type { IDeleteDashboardFolderModal } from './delete-dashboard-folder-modal.types'

export const useDeleteDashboardFolderModalModel = (): IDeleteDashboardFolderModal => {
  const { setIsDeleteDashboardFolderOpen, folder } = useDashboardModals()
  const { createToast } = useToast()
  const t = useTranslate()

  const [deleteJobExternalFolder, { loading }] = useDashboardMutations({
    errorLog: DELETE_DASHBOARD_FOLDER_LOG,
    mutationName: 'deleteJobExternalFolder',
    options: {
      refetchQueries: ['getListWorkspaceJobPaginated', 'GET_JOB_EXTERNAL_FOLDERS'],
    },
  })

  const handleDelete = () => {
    if (!folder?.id) {
      createToast({
        content: t(TOLGEE_GLOBALS.somethingWentWrong),
      })
      closeModal()
      return
    }

    const { DASHBOARD_FOLDERS } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(DASHBOARD_FOLDERS.DELETE_FOLDER, {
      folderName: folder.name,
      folderId: folder.id,
    })

    deleteJobExternalFolder({
      variables: {
        input: {
          folderId: folder.id,
        },
      },
    })
      .then(({ data }) => {
        if (data.deleteWorkspaceJobExternalFolder?.success) {
          createToast({
            content: t(translations.deletedMessage),
          })
        }
      })
      .catch(() => {
        createToast({
          content: t(TOLGEE_GLOBALS.somethingWentWrong),
        })
      })
      .finally(() => {
        closeModal()
      })
  }

  const closeModal = () => {
    setIsDeleteDashboardFolderOpen(false)
  }

  return {
    loading,
    handleDelete,
    closeModal,
  }
}
